<!--
 * @Author: your name
 * @Date: 2021-04-22 15:42:46
 * @LastEditTime: 2021-08-06 10:30:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\src\views\addCity.vue
-->


<template>
  <div class="real-name">
    <div class="real-main">
      <van-field v-model="from.consignee" placeholder="请输入收货人" label="收货人" />
      <van-field v-model="from.phone" type="tel" placeholder="请输入收货人手机号" label="手机号" />
      <van-field
        v-model="cityarea"
        right-icon="arrow"
        value="所在地区"
        placeholder="请选择省市区"
        readonly
        label="所在地区"
        @click="openCityFg"
      />
      <van-field
        v-model="from.address"
        rows="1"
        autosize
        label="详细地址"
        type="textarea"
        placeholder="如道路 门牌号 小区 楼栋号 单元等"
      />
      <van-action-sheet v-model="show" title="请选择所在地区">
        <div class="n_toppad">
          <div class="n_top">
            <div
              :class="[isParams == 'isProvince' ? 'n_active' : '','n_right']"
              @click="hereClickFg('isProvince',provinceName)"
            >{{provinceName.name}}</div>
            <div
              :class="[isParams == 'isCity' ? 'n_active' : '','n_right']"
              @click="hereClickFg('isCity',cityName)"
            >{{cityName.name}}</div>
            <div
              :class="[isParams == 'isArea' || '' ? 'n_active' : '','n_right']"
              @click="hereClickFg('isArea',areaName)"
            >{{areaName.name}}</div>
            <div
              :class="[isParams == 'district' || '' ? 'n_active' : '','n_right']"
              @click="hereClickFg('district',districtName)"
            >{{districtName.name}}</div>
          </div>
          <div class="n_scroll">
            <div v-if="isParams == 'isProvince'">
              <div
                v-for="i in provinceList"
                :key="i.id"
                class="n_city"
                @click="getArea(i,'isProvince','isCity')"
              >{{i.name}}</div>
            </div>
            <div v-if="isParams == 'isCity'">
              <div
                v-for="i in cityList"
                :key="i.id"
                class="n_city"
                @click="getArea(i,'isCity','isArea')"
              >{{i.name}}</div>
            </div>
            <div v-if="isParams == 'isArea'">
              <div
                v-for="i in areaList"
                :key="i.id"
                class="n_city"
                @click="getArea(i,'isArea','district')"
              >{{i.name}}</div>
            </div>
            <div v-if="isParams == 'district'">
              <div
                v-for="i in districtList"
                :key="i.id"
                class="n_city"
                @click="getArea(i,'district','')"
              >{{i.name}}</div>
            </div>
          </div>
        </div>
      </van-action-sheet>
      <div class="set-city flex-b">
        <div>设为默认地址</div>
        <div>
          <span
            @click="settingFg"
            :class="['iconfont', ismsg == 'iconselected' ? 'iconweixuanzhong' : 'iconselected']"
          ></span>
        </div>
      </div>
    </div>
    <div class="save-real" @click="creatAddressFg">保存</div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'realName',
  data() {
    return {
      from: { consignee: '' },
      id: '',
      phone: '',
      code: '',
      show: false,
      message: '',
      provinceName: {},
      cityName: {},
      areaName: {},
      districtName: {},
      provinceList: [],
      cityList: [],
      areaList: [],
      districtList: [],
      isParams: 'isProvince',
      cityarea: '',
      ismsg: 'iconselected',
      districtName1: {},
      flag: false,
    }
  },
  created() {
    if (this.$route.query.id && this.$route.query.id != '') {
      this.id = this.$route.query.id || ''
      this.getDetail()
    }
    this.getArea(0, 'isProvince', 'isProvince')
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    //设置默认
    settingFg() {
      this.ismsg =
        this.ismsg == 'iconselected' ? 'iconweixuanzhong' : 'iconselected'
      console.log(this.ismsg)
      // this.http('ClientAddress.setDefaultAddress', {
      //   is_default: this.ismsg == 'iconselected' ? 1 : 0,
      //   address_id: this.id,
      // }).then((res) => {
      //   console.log(res)
      // })
    },
    //获取城市
    getArea(e, params, name) {
      this.http('Base.getCityList', { pid: e.id }).then((res) => {
        console.log(res)
        this.isParams = name
        if (name == 'isCity') {
          this.cityList = res.content.list
          this.provinceName = e
          this.cityName.name = '请选择'
          this.areaName.name = ''
          this.districtName.name = ''
        } else if (name == 'isProvince') {
          this.provinceList = res.content.list
          this.provinceName.name = e.name ? e : '请选择'
        } else if (name == 'isArea') {
          console.log(res.content.list)
          this.areaList = res.content.list
          this.cityName = e
          this.areaName.name = '请选择'
        } else if (name == 'district') {
          this.areaName = e
          this.districtName1 = e
          this.districtList = [
            { id: -100, name: '暂不选择' },
            ...res.content.list,
          ]
          this.districtName.name = '请选择'
        } else if (name == '') {
          console.log(e)
          this.districtName = e
          this.districtName1 = e.id > 0 ? e : this.districtName1
          this.cityarea =
            this.provinceName.name +
            this.cityName.name +
            this.areaName.name +
            this.districtName.name
          this.show = false
        }
      })
    },
    // 弹出城市
    openCityFg() {
      console.log(this.provinceName)
      this.provinceName = {}
      this.cityName = {}
      this.areaName = {}
      this.districtName = {}
      this.getArea(0, 'isProvince', 'isProvince')
      this.show = true
    },
    hereClickFg(e, city) {
      console.log(e, city)
      this.isParams = e
    },
    //新增
    async creatAddressFg() {
      console.log(this.districtName1)
      if (this.flag) return
      this.flag = true
      if (!/^[1][0-9]{10}$/.test(this.from.phone)) {
        Toast('手机号码有误，请重填')
        this.flag = false
        return false
      }
      this.from.address_id = this.id
      this.from.area_code = this.districtName1.id
      this.from.is_default = this.ismsg == 'iconweixuanzhong' ? '1' : '0'
      console.log(this.from)
      let res = await this.http('ClientAddress.addAddress', { ...this.from })
      if (res.status == 200) {
        Toast(this.id == '' ? '新建地址成功' : '修改地址成功')
        setTimeout(() => {
          this.$router.go(-1)
          this.flag = false
        }, 500)
      } else {
        Toast(res.msg)
        this.flag = false
      }
    },
    //获取地址详情
    async getDetail() {
      let res = await this.http('ClientAddress.getAddressDetail', {
        address_id: this.id,
      })
      let cmit = res.content
      this.from = res.content
      this.cityarea =
        cmit.address_detail.level_1_name +
        cmit.address_detail.level_2_name +
        cmit.address_detail.level_3_name +
        cmit.address_detail.level_4_name
      this.from.area_code = cmit.area_code
      this.districtName.id = cmit.address_detail.level_4_id
      this.districtName1.id = cmit.area_code
      this.ismsg = cmit.is_default == 1 ? 'iconweixuanzhong' : 'iconselected'
      this.provinceName = {
        name: res.content.address_detail.level_1_name,
        id: res.content.address_detail.level_1_id,
      }
      this.cityName = {
        name: res.content.address_detail.level_2_name,
        id: res.content.address_detail.level_2_id,
      }
      this.areaName = {
        name: res.content.address_detail.level_3_name,
        id: res.content.address_detail.level_3_id,
      }
      this.districtName = {
        name: res.content.address_detail.level_4_name,
        id: res.content.address_detail.level_4_id,
      }
      if (res.content.address_detail.level_4_id) {
        this.districtName1 = {
          name: res.content.address_detail.level_4_name,
          id: res.content.address_detail.level_4_id,
        }
      }

      console.log(res)
    },
  },
}
</script>

<style lang="scss" scoped>
.iconselected {
  color: #ee0a24;
}
.iconfont {
  font-size: 36px;
}
.real-name {
  width: 100vw;
  min-height: 100vh;
  background: #f8f8f8;
  .real-main {
    border-top: 20px solid #f8f8f8;
  }
  .code {
    position: relative;
    width: 750px;
    height: 88px;
    .obtain-code {
      width: 140px;
      height: 100%;
      position: absolute;
      right: 30px;
      top: 0;
      font-size: 28px;
      font-weight: 400;
      color: #f0240e;
      line-height: 88px;
    }
  }
  .save-real {
    width: 686px;
    height: 96px;
    background: #ee0a24;
    border-radius: 48px;
    font-size: 32px;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    margin: 158px auto;
    line-height: 96px;
  }
  .set-city {
    padding: 0 20px;
    background: #ffffff;
    border-top: 20px solid #f8f8f8;
    font-size: 28px;
    font-weight: 400;
    color: #323233;
    line-height: 88px;
  }
}
.n_toppad {
  padding: 28px 32px;
}
.n_top {
  display: flex;
  margin-bottom: 40px !important;
}
.n_scroll {
  height: 60vh;
  overflow: hidden;
  overflow-y: scroll;
}

.n_right {
  position: relative;
  margin-right: 40px;
  padding: 28px 0;
  font-size: 28px;
  color: #323233;
}
.n_active {
  transition: all 0.3s;
}
.n_active::after {
  content: '';
  position: absolute;
  right: 50%;
  transform: translate(50%);
  top: 88px;
  width: 80px;
  height: 6px;
  border-radius: 20px;
  background: rgba(240, 36, 14, 1);
  transition: all 0.3s;
}
.n_city {
  margin-bottom: 40px;
}
</style>
<style>
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.real-name .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.real-name .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>